import _ from 'lodash';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Select, ISelectProps } from '../../../../../../../../../../../lib/esm/components';
import {
    ISelectedOption,
    TSelectedOptions,
} from '../../../../../../../../../../../lib/esm/components/Select/configurations';
import { FormItem } from '../../styles';
import { MAIN_RATING_INDICATORS } from '../../../../constants/constants';

const SelectMainIndicator: React.FC<
    ISelectProps & { selectedId: string | undefined; handleSelectValue: (selects: TSelectedOptions) => void }
> = ({ handleSelectValue, selectedId = '' }) => {
    const [selectedMainIndicator, setSelectedMetrics] = useState<TSelectedOptions>([]);
    const { t } = useTranslation();
    const options = useMemo(() => {
        return _.cloneDeep(MAIN_RATING_INDICATORS).map((item) => {
            return { ...item, text: t(item.text) };
        });
    }, [t]);

    const handleSelect = (args: TSelectedOptions) => {
        if (args.length) {
            setSelectedMetrics([args[0]]);
            handleSelectValue(args);
        }
    };

    const metricSelect = useMemo(() => {
        let outsideSelected: TSelectedOptions = [];
        const outsideSelect = options?.find((x: ISelectedOption) => x.id === selectedId);
        if (outsideSelect) {
            outsideSelected = [outsideSelect];
        } else {
            outsideSelected = [options[0]];
        }

        return (
            <Select
                options={options}
                showFilter={false}
                labelText={t('Build rating by')}
                iconType={'chevron-down'}
                mode="single"
                shadow="md"
                handleSelect={handleSelect}
                outsideSelected={outsideSelected}
            />
        );
    }, [selectedMainIndicator, options, t, selectedId]);

    return <FormItem>{metricSelect}</FormItem>;
};
export default SelectMainIndicator;
